module.exports = __webpack_public_path__ + "img/ic-install-app-header-underline.5d82a77b.svg";